import { render, staticRenderFns } from "./fcwpContent.vue?vue&type=template&id=08b988e5&"
import script from "./fcwpContent.vue?vue&type=script&lang=js&"
export * from "./fcwpContent.vue?vue&type=script&lang=js&"
import style0 from "./fcwpContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports